import styled from 'styled-components';

export const ClearIconSC = styled.button`
  min-width: 36px;
  height: 36px;
  min-height: 36px;

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  outline: none;
  border: none;
  background: none;
  cursor: pointer;

  :active {
    opacity: 0.5;
  }
`;

export const InputSeparator = styled.span`
  height: 24px;
  margin-left: 12px;
  border-right-width: 1px;
  border-right-style: solid;
`;
